module.exports = __webpack_public_path__ + "static/img/miura_02.2df7e9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/miura_02.png
// module id = xqZd
// module chunks = 0